import { styled } from '@mui/material/styles';
import ListItem from '@mui/material/ListItem';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const StyledListItem = styled(ListItem)(({ theme }) => ({
    border: 1,
    borderColor: theme.palette.divider,
    borderStyle: 'solid',
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(1)
}));

export const VersionInfoBox = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: 8
});

export const LanguageTypography = styled(Typography)({
    fontWeight: "bold"
});
